import './index.styl';
import { Model } from 'backbone';
import { View } from 'backbone.marionette';
import template from './index.jst';

import _ from 'lodash';
import Radio from "backbone.radio";

const fieldChannel = Radio.channel('field');

export class PlayerPoolFiltres extends View {
	get template() {
		return template;
	}

	ui() {
		return {
			filters: 'form',
			search: '#player-pool-search',
			btn_more: '.js-player-pool-more-filters',
			btn_less: '.js-player-pool-less-filters',
			more_filters: '.js-player-pool-more-filters-container',
			btn_search: '.js-player-pool-search-icon'
		}
	}

	events() {
		return {
			'keyup @ui.search': 'onChangeFilter',
			'change @ui.filters': 'onChangeFilter',
			'click @ui.btn_search': 'doNothing',
			'click @ui.btn_more': 'toggleFilters',
			'click @ui.btn_less': 'toggleFilters',
		}
	}

	initialize() {
		this.model = new Model({
			filter: {},
			selected: {},
			is_visible_filters: false
		});

		this.initListeners();
	}

	initListeners() {
		this.listenTo(fieldChannel, 'change:stat:field', this.updateOrderFilter);
		this.listenTo(this.model, 'change', this.render);

		return this;
	}

	get order_by_options() {
		return [
			{ key: '', value: 'Order By' },
			{ key: 'cost', value: 'Price' },
			{ key: 'name', value: 'Alphabetical' },
			{ key: 'stats.avg_points', value: 'Average (AVG)' },
			{ key: 'stats.total_points', value: 'Total points (TOT)' },
			{ key: 'stats.points_last_round', value: 'Points Last Round' },
			{ key: 'stats.owned_by', value: 'Selected by % (TS%)' },
			{ key: 'stats.cost_divided_by_points', value: '$ / Points ($/PTS)' },
			{ key: 'stats.last_3_avg', value: 'Form (L3 AVG)' },
			{ key: 'stats.break_even', value: 'Breakeven' },
			{ key: 'stats.proj_score', value: 'Projected Score' }
		];
	}

	getFilterByPriceOptions(remaining_salary) {
		return [
			{ key: '', value: 'By Price' },
			{ key: '800-99999', value: '800k+' },
			{ key: '600-800', value: '600-800k' },
			{ key: '400-600', value: '400-600k' },
			{ key: '300-400', value: '300-400k' },
			{ key: '0-300', value: '0-300k' },
			{ key: `0-${remaining_salary / 1000}-by_locked`, value: 'Players I can afford' },
		];
	}

	correctFilterByPrice(by_price_options) {
		const { filter_by_price } = this.model.get('selected');

		if (!filter_by_price) {
			return _.first(by_price_options).key;
		}

		const selected = (
			_.find(by_price_options, { key: filter_by_price }) || _.last(by_price_options)
		);

		return selected.key;
	}

	init(args) {
		const {
			squads,
			positions,
			remaining_salary,
			last_round_id,
			actual_round_id,
			next_round_id,
			scheduled_round_id,
			quick_trade,
			most_recent_round_id
		} = args;

		const
			trade_pos = _.result(quick_trade, '[0].pos'),
			by_price = this.getFilterByPriceOptions(remaining_salary),
			filter_by_price = (
				trade_pos ? _.last(by_price).key : this.correctFilterByPrice(by_price)
			),
			selected = {
				...this.model.get('selected'),
				filter_by_price,
			};

		if (trade_pos) {
			selected.filter_by_position = (trade_pos === 'bench' ? '' : trade_pos);
		}

		this.model.set({
			last_round_id,
			actual_round_id,
			next_round_id,
			scheduled_round_id,
			most_recent_round_id,
			selected,
			filter: {
				by_price,
				squads,
				positions,
				order_by: this.order_by_options,
			}
		});

		if (filter_by_price) {
			this.trigger('filter:players', selected);
		}
	}

	switchPositionSelect({ pos }) {
		pos = pos === 'bench' ? '' : pos;

		const selected = {
			...this.model.get('selected'),
			filter_by_position: pos
		};

		this.model.set({ selected });

		this.trigger('filter:players', selected);
	}

	onChangeFilter(event, params = { silent: true }) {
		let { name, value, checked, type } = event.target,
			is_checkbox = type === 'checkbox',
			selected = {
				...this.model.get('selected'),
				[name]: is_checkbox ? checked : value
			};
		this.model.set({ selected }, params);

		this.trigger('filter:players', selected);
	}

	updateOrderFilter(selected_stats){
		const selected = {
			...this.model.get('selected'),
			'order_by': selected_stats
		};

		this.model.set({ selected });

		this.trigger('filter:players', selected);
	}

	doNothing(event) {
		event.preventDefault();
	}

	toggleFilters() {
		const changes = {
			is_visible_filters: !this.model.get('is_visible_filters')
		};

		this.model.set(changes, { silent: true });

		this.ui.btn_more.toggleClass('hidden');
		this.ui.btn_less.toggleClass('hidden');
		this.ui.more_filters.toggleClass('hidden');

		this.trigger('filter:change:state', changes);
	}
}

export default PlayerPoolFiltres;